import { createActions } from 'redux-actions';
import { GetAllOrderParams } from '@apis/OrderApi';
import { OrderList } from '@models/Order';
import { Pagination } from '@models/Pagination';

export type State = {
  orders?: OrderList[] | null;
  pagination?: Pagination;
}

export type OrdersFetchPayload = GetAllOrderParams;
export type StateUpdatePayload = Partial<State>;

export const {
  ordersFetch,
  stateUpdate,
} = createActions(
  'ORDERS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_POLICY',
  },
);
